export const XL_MINIMAL_WIDTH = 1904
export const PASSWORD_MIN_HEIGHT = 128
